module.exports = __webpack_public_path__ + "img/dashboard.92f2cc5e.png";